import { ReduxSliceContainer } from '@app/packages/reduxSlice/reduxSlice'

export const BASE_REDUX_SLICE_CONTAINER = new ReduxSliceContainer('redux_slice')

export const createReduxSlice = BASE_REDUX_SLICE_CONTAINER.createSlice
